import React,{useState, useEffect} from 'react'
import {TableCell,TableBody, TableContainer, Table, TableHead, TableRow, Box, IconButton, Dialog,AppBar,Grid, Toolbar, DialogTitle, DialogContent,  Menu, MenuItem,Button, Typography} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import  CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import {deleteClientId, setClient} from "../../actions/client";
import {setProperty, deleteproperty} from "../../actions/property";
import {setReport, deleteReportData} from "../../actions/report";
import {setTree, deleteReportTree, fetchAllTrees} from "../../actions/tree";
import { useDispatch, useSelector } from 'react-redux';
import { profileSettingStyles } from '../../styles/materialComponent';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import Swal from "sweetalert2";
import { validateUserType } from '../../ValidateUserType';
import { deleteArborId, setArbor } from '../../actions/arboristLogin';

const CommonTable = ({lable, tableCols, tableRows, formik, setActiveStep, component, setEditClick,setEditTreeClick, setShow}) => {
  console.log(tableRows)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const classes = profileSettingStyles()
  const [selectedItemRow, setSelectedRow] = useState(null)
  const [open,setOpen] = useState(false)
  const {editReport} = useSelector(({report})=> report)
  const {reportTrees} = useSelector(({tree})=> tree)

  const sortedData = [...reportTrees].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
  
  const [anchorEl, setAnchorEl] = useState(null);
  function handleCloses() {
    setAnchorEl(null);
    setSelectedRow(null)
  }
  const handleClose = () => {
    setOpen(false);
  };


  function handleClick(event, row) {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row)
  }


  const handleEdit = (row)=>{
   
    switch(lable){

      case "arbor":
        dispatch(setArbor(row))
        navigate("/editArbor")
        handleCloses()
        break;
      case "client":
        dispatch(setClient(row))
        navigate("/editClient")
        handleCloses()
        break;
      case "property":
        dispatch(setProperty(row))
        navigate("/editProperty")
        handleCloses()
        break;
      case "clientContact":
        dispatch({type:"SET_CLIENT_DETAIL", payload:row})
        handleCloses()
        break;
      case "reports":
        dispatch(setReport(row))
        navigate("/editReport", {state:{data:"/reports"}})

        handleCloses()
        break;
      case "trees":
        dispatch(setTree(row))
        setEditTreeClick(true)
        // setShow(true)
        setActiveStep(7)
        handleCloses()
        break;
      case "generateReport":
        dispatch(setTree(row))
        setEditClick(true)
        // navigate("/editReport", {state:{data:"/addReport"}})
        setActiveStep(4)
        handleCloses()
        break;
        default:
          return;
    }

  }
  const handleDelete = (row)=>{
    switch(lable){
      case "arbor":
        Swal.fire({
          title: 'Are you sure?',
          text: 'It will be permanently deleted',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes!'
        }).then((result) => {
          if (result.isConfirmed) {
          dispatch(deleteArborId(row))
          Swal.fire('Arbor deleted successfully', '', 'success');
          }
          else{
          Swal.fire('You cancelled the request', '', 'error') }
      })
        handleCloses()
        break;
      case "client":
           Swal.fire({
            title: 'Are you sure?',
            text: 'It will be permanently deleted',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes!'
          }).then((result) => {
            if (result.isConfirmed) {
            dispatch(deleteClientId(row,tableRows[0].arborist))
            Swal.fire('Client deleted successfully', '', 'success');
            }
            else{
            Swal.fire('You cancelled the request', '', 'error') }
        })
        handleCloses()
        break;
      case "property":
        Swal.fire({
          title: 'Are you sure?',
          text: 'It will be permanently deleted',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes!'
        }).then((result) => {
          if (result.isConfirmed) {
          dispatch(deleteproperty(row,tableRows[0]))
          Swal.fire('Property deleted successfully', '', 'success');
          } else{
          Swal.fire('You cancelled the request', '', 'error') }
      })
      handleCloses()
      break;
      case "clientContact":
        Swal.fire({
          title: 'Are you sure?',
          text: 'It will be permanently deleted',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes!'
        }).then((result) => {
          if (result.isConfirmed) {
            dispatch({type:"DELETE_CLIENT_CONTACT", payload:row._id})
          Swal.fire('contact Details deleted successfully', '', 'success');
          }  else{
            Swal.fire('You cancelled the request', '', 'error') }
      })
      handleCloses()
      break;
      case "trees":
        Swal.fire({
          title: 'Are you sure?',
          text: 'It will be permanently deleted',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes!'
        }).then((result) => {
          if (result.isConfirmed) {
          dispatch(deleteReportTree(row?.report, row?._id))
          Swal.fire('Report Tree deleted successfully', '', 'success');
          }  else{
            Swal.fire('You cancelled the request', '', 'error') }
      })
      handleCloses()
      break;
      case "generateReport":
        Swal.fire({
          title: 'Are you sure?',
          text: 'It will be permanently deleted',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes!'
        }).then((result) => {
          if (result.isConfirmed) {
          dispatch(deleteReportTree(row?.report, row?._id))
          Swal.fire('Report Tree deleted successfully', '', 'success');
          } else{
            Swal.fire('You cancelled the request', '', 'error') }
      })
      handleCloses()
      break;
      case "reports":
        Swal.fire({
          title: 'Are you sure?',
          text: 'It will be permanently deleted',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes!'
        }).then((result) => {
          if (result.isConfirmed) {
          dispatch(deleteReportData(row))
          Swal.fire('Report deleted successfully', '', 'success');
          }  else{
            Swal.fire('You cancelled the request', '', 'error') }
      })
      handleCloses()
      break;
        default:
          return;
      }
  }
  return (
    <>
      <TableContainer>
        <Table sx = {{minWidth: lable === "clientContact" ? 400 : 650}} className = {lable === "clientContact" && classes.textField1} aria-label="simple table">
        <TableHead >
          <TableRow>
        {
          tableCols?.map((tab, index)=>
            <TableCell align="left" variant="h4">{tab}</TableCell>
          )
        }
            </TableRow>
            </TableHead>
            <TableBody>
              {
                lable === "reports" &&
                tableRows?.length ? tableRows?.map((row, index)=>
              <TableRow>
                <TableCell>{row?.reportName}</TableCell>
                <TableCell>{index+1}</TableCell>
                <TableCell>{row?.client?.clientName}</TableCell>
                <TableCell>{row?.property?.propertyName}</TableCell>
                <TableCell>
                  <Box>
                  <IconButton
                    aria-label="More"
                    aria-owns={open ? "long-menu" : undefined}
                    aria-haspopup="true"
                    onClick={(event)=>handleClick(event, row)}
                    style={{backgroundColor:"gray", color:"white", borderRadius:"4px", padding:7}}
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    open={Boolean(anchorEl && selectedItemRow === row)}
                    id="long-menu"
                    anchorEl={anchorEl}
                    onClose={handleCloses}
                  >
                      <MenuItem onClick={handleClose} >
                      <IconButton onClick={()=>handleDelete(row?._id)}>
                      <DeleteIcon /><Typography style={{marginLeft:5}}>Delete</Typography>
                      </IconButton>
                      </MenuItem>
                  </Menu>
              </Box>
                  </TableCell>
                <TableCell>
                  <Button variant ="contained"
                    onClick={()=>handleEdit(row)}
                    style={{backgroundColor:"rgb(115 74 153)",
                            textTransform:"none",
                            height:30}}
                            >
                  {row?.status?.charAt(0).toUpperCase() + row?.status?.slice(1)}
                  </Button>
                  </TableCell>

                </TableRow>
                ):null
              }
              {
                lable === "client" &&
                tableRows?.length ? tableRows?.map((row)=>
                <TableRow>
                <TableCell>{row.clientName}</TableCell>
                <TableCell>{row.address}</TableCell>
                <TableCell>
                <Box>
                  <IconButton
                    aria-label="More"
                    aria-owns={open ? "long-menu" : undefined}
                    aria-haspopup="true"
                    onClick={(event)=>handleClick(event, row)}
                    style={{backgroundColor:"gray", color:"white", borderRadius:"4px", padding:7}}
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    open={Boolean(anchorEl && selectedItemRow === row)}
                    id="long-menu"
                    anchorEl={anchorEl}
                    onClose={handleCloses}
                  >
                      <MenuItem onClick={handleClose} >
                      <IconButton onClick={()=>handleEdit(row)}>
                      <EditIcon /><Typography style={{marginLeft:5}}>Edit</Typography>
                      </IconButton>
                      </MenuItem>
                      <MenuItem onClick={handleClose} >
                      <IconButton onClick={()=>handleDelete(row)}>
                      <DeleteIcon /><Typography style={{marginLeft:5}}>Delete</Typography>
                        </IconButton>
                      </MenuItem>

                  </Menu>
              </Box>
                {/* <IconButton aria-label="Edit" onClick={()=>handleEdit(row)}>
                <EditIcon />
                </IconButton> */}
                </TableCell>
                {/* <TableCell>
                <IconButton aria-label="Delete" onClick={()=>handleDelete(row._id)}>
                <DeleteIcon />
                  </IconButton>
                </TableCell> */}
            </TableRow>
                ):null
              }
                {
                lable === "property" &&
                tableRows?.length ? tableRows?.map((row, index)=>
                <TableRow>
                <TableCell>{row?.propertyName}</TableCell>
                <TableCell>{row?.client?.clientName}</TableCell>
                <TableCell>{row?.location}</TableCell>
                <TableCell>
                <Box>
                  <IconButton
                    aria-label="More"
                    aria-owns={open ? "long-menu" : undefined}
                    aria-haspopup="true"
                    onClick={(event)=>handleClick(event, row)}
                    style={{backgroundColor:"gray", color:"white", borderRadius:"4px", padding:7}}
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    open={Boolean(anchorEl && selectedItemRow === row)}
                    id="long-menu"
                    anchorEl={anchorEl}
                    onClose={handleCloses}
                    >
                      <MenuItem onClick={handleClose} >
                      <IconButton onClick={()=>handleEdit(row)}>
                      <EditIcon /><Typography style={{marginLeft:5}}>Edit</Typography>
                      </IconButton>
                      </MenuItem>
                      <MenuItem onClick={handleClose} >
                      <IconButton onClick={()=>handleDelete(row)}>
                      <DeleteIcon /><Typography style={{marginLeft:5}}>Delete</Typography>
                      </IconButton>
                      </MenuItem>
                  </Menu>
              </Box>
                {/* <IconButton aria-label="Edit" onClick={()=>handleEdit(row)}>
                <EditIcon />
                </IconButton> */}
                </TableCell>
                {/* <TableCell>
                <IconButton aria-label="Delete" onClick={()=>handleDelete(row._id)}>
                <DeleteIcon />
                  </IconButton>
                </TableCell> */}
            </TableRow>
                ):null
              }
               {
                validateUserType()&&
                lable === "arbor" &&
                tableRows?.length ? tableRows?.map((row)=>
                <TableRow>
                <TableCell>{`${row.firstName} ${row.lastName}`}</TableCell>
                <TableCell>{row.address}</TableCell>
                <TableCell>
                <Box>
                  <IconButton
                    aria-label="More"
                    aria-owns={open ? "long-menu" : undefined}
                    aria-haspopup="true"
                    onClick={(event)=>handleClick(event, row)}
                    style={{backgroundColor:"gray", color:"white", borderRadius:"4px", padding:7}}
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    open={Boolean(anchorEl && selectedItemRow === row)}
                    id="long-menu"
                    anchorEl={anchorEl}
                    onClose={handleCloses}
                  >
                      <MenuItem onClick={handleClose} >
                      <IconButton onClick={()=>handleEdit(row)}>
                      <EditIcon /><Typography style={{marginLeft:5}}>Edit</Typography>
                      </IconButton>
                      </MenuItem>
                      <MenuItem onClick={handleClose} >
                      <IconButton onClick={()=>handleDelete(row._id)}>
                      <DeleteIcon /><Typography style={{marginLeft:5}}>Delete</Typography>
                        </IconButton>
                      </MenuItem>

                  </Menu>
              </Box>
                {/* <IconButton aria-label="Edit" onClick={()=>handleEdit(row)}>
                <EditIcon />
                </IconButton> */}
                </TableCell>
                {/* <TableCell>
                <IconButton aria-label="Delete" onClick={()=>handleDelete(row._id)}>
                <DeleteIcon />
                  </IconButton>
                </TableCell> */}
            </TableRow>
                ):null
              }
                {
                lable === "clientContact" &&
                tableRows?.length ? tableRows?.map((row)=>
                <TableRow>
                <TableCell>{row?.name}</TableCell>
                <TableCell>{row?.email}</TableCell>
                <TableCell>{row?.phone} </TableCell>
                <TableCell>
                <Box>
                  <IconButton
                    aria-label="More"
                    aria-owns={open ? "long-menu" : undefined}
                    aria-haspopup="true"
                    onClick={(event)=>handleClick(event, row)}
                    style={{backgroundColor:"gray", color:"white", borderRadius:"4px", padding:7}}
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    open={Boolean(anchorEl && selectedItemRow === row)}
                    id="long-menu"
                    anchorEl={anchorEl}
                    onClose={handleCloses}
                  >
                      <MenuItem onClick={handleClose}>
                      <IconButton onClick={()=>handleEdit(row)}>
                      <EditIcon /><Typography style={{marginLeft:5}}>Edit</Typography>
                      </IconButton>
                      </MenuItem>
                      <MenuItem onClick={handleClose} >
                      <IconButton  onClick={()=>handleDelete(row)}>
                      <DeleteIcon /><Typography style={{marginLeft:5}}>Delete</Typography>
                        </IconButton>
                      </MenuItem>

                  </Menu>
              </Box>

                </TableCell>

                {/* <TableCell>Test</TableCell> */}
              </TableRow>
                ):null
              }
               {
                lable === "trees" &&
                tableRows?.length ?  tableRows?.map((row)=>
                <TableRow>
                <TableCell>{row?.treeHeight}</TableCell>
                <TableCell>{row?.species?.commonName}</TableCell>
                <TableCell>{row?.recomendation?.recomendation} </TableCell>
                <TableCell>{row?.treeImages?.length ? row?.treeImages?.map((image)=> <img src={image} height="50" width="50" style={{margin:2}}/>):"No image"}</TableCell>

                {/* <TableCell>
                  {row?.treeImages?.length && <IconButton onClick={()=> setOpen(true)}><VisibilityOutlinedIcon /></IconButton>}
                </TableCell> */}
                <TableCell>
                <Box>
                  <IconButton
                    aria-label="More"
                    aria-owns={open ? "long-menu" : undefined}
                    aria-haspopup="true"
                    onClick={(event)=>handleClick(event, row)}
                    style={{backgroundColor:"gray", color:"white", borderRadius:"4px", padding:7}}
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    open={Boolean(anchorEl && selectedItemRow === row)}
                    id="long-menu"
                    anchorEl={anchorEl}
                    onClose={handleCloses}
                  >
                      <MenuItem onClick={handleClose} >
                      <IconButton onClick={()=>handleEdit(row)}>
                      <EditIcon /><Typography style={{marginLeft:5}}>Edit</Typography>
                      </IconButton>
                      </MenuItem>
                      <MenuItem onClick={handleClose} >
                      <IconButton onClick={()=>handleDelete(row)}>
                      <DeleteIcon /><Typography style={{marginLeft:5}}>Delete</Typography>
                      </IconButton>
                      </MenuItem>
                  </Menu>
              </Box>
                {/* <IconButton aria-label="Edit" onClick={()=>handleEdit(row)}>
                <EditIcon />
                </IconButton> */}
                </TableCell>
                {/* <Dialog
              style={{padding:2}}
              onClose={handleClose}
              aria-labelledby="customized-dialog-title"
              open={open}
          >
          <AppBar sx={{ position: 'relative', backgroundColor:"#FCFBFD" }}>
        <Toolbar>
          <IconButton
            edge="start"
            // color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          </Toolbar>
        </AppBar>
        <DialogTitle>

        </DialogTitle>
        <DialogContent dividers>
        <div className="book-display">
          <Grid container spacing={4} justifyContent="center">
          {row?.treeImages?.length ? row?.treeImages?.map((image)=>
            <Grid item xs={12} sm={12} lg={4} md={4} style={{display: "flex", justifyContent: "center"}}>
            <img src={image} alt="image" height="200" width="200" />
            </Grid>
            ):null}

          </Grid>
        </div>
      </DialogContent>
    </Dialog> */}
                {/* <TableCell>Test</TableCell> */}
              </TableRow>
                ):null
              }
               {
                lable === "generateReport" &&
                tableRows?.length ? tableRows?.map((row)=>
                <TableRow>
                <TableCell>{row?.treeHeight}</TableCell>
                <TableCell>{row?.species?.commonName}</TableCell>
                <TableCell>{row?.recomendation?.recomendation} </TableCell>
                <TableCell>{row?.treeImages?.length ? row?.treeImages?.map((image)=> <img src={image} height="50" width="50" style={{margin:2}}/>):"No Image"}</TableCell>
                  {/* {row?.treeImages?.length && <IconButton onClick={()=> setOpen(true)}><VisibilityOutlinedIcon /></IconButton>}
                </TableCell> */}
                <TableCell>
              {  component !== "addTree" &&<Box>
                  <IconButton
                    aria-label="More"
                    aria-owns={open ? "long-menu" : undefined}
                    aria-haspopup="true"
                    onClick={(event)=>handleClick(event, row)}
                    style={{backgroundColor:"gray", color:"white", borderRadius:"4px", padding:7}}
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    open={Boolean(anchorEl && selectedItemRow === row)}
                    id="long-menu"
                    anchorEl={anchorEl}
                    onClose={handleCloses}
                  >
                      <MenuItem onClick={handleClose} >
                      <IconButton onClick={()=>handleEdit(row)}>
                      <EditIcon /><Typography style={{marginLeft:5}}>Edit</Typography>
                      </IconButton>
                      </MenuItem>
                      <MenuItem onClick={handleClose} >
                      <IconButton  onClick={()=>handleDelete(row)}>
                      <DeleteIcon /><Typography style={{marginLeft:5}}>Delete</Typography>
                        </IconButton>
                      </MenuItem>

                  </Menu>
              </Box>}

                </TableCell>
                {/* <Dialog
              style={{padding:2}}
              onClose={handleClose}
              aria-labelledby="customized-dialog-title"
              open={open}
          >
          <AppBar sx={{ position: 'relative', backgroundColor:"#FCFBFD" }}>
        <Toolbar>
          <IconButton
            edge="start"
            // color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          </Toolbar>
        </AppBar>
        <DialogTitle>

        </DialogTitle>
        <DialogContent dividers>
        <div className="book-display">
          <Grid container spacing={4} justifyContent="center">
          {row?.treeImages?.length ? row?.treeImages?.map((image)=>
            <Grid item xs={12} sm={12} lg={4} md={4} style={{display: "flex", justifyContent: "center"}}>
            <img src={image} alt="image" height="200" width="200" />
            </Grid>
            ):null}

          </Grid>
        </div>
      </DialogContent>
    </Dialog> */}
                {/* <TableCell>Test</TableCell> */}
              </TableRow>
                ):null
              }
                </TableBody>
            </Table>
            </TableContainer>
    </>
  )
}

export default CommonTable